import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPortalDashboardUrl, openedFromPortal } from '@platzona/auth-client';
import './PortalBackButton.css';

export interface PortalBackButtonProps {
  /** i18n key for the back link (default: nav.backToPortal) */
  labelKey?: string;
  /** i18n key for dismiss button aria-label (default: common.dismiss) */
  dismissKey?: string;
}

/** Floating chip when a platform was opened from the portal (?from_portal=1). */
export function PortalBackButton({
  labelKey = 'nav.backToPortal',
  dismissKey = 'common.dismiss',
}: PortalBackButtonProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => openedFromPortal());
  if (!visible) return null;

  return (
    <div className="portal-back-button">
      <a href={getPortalDashboardUrl()} className="portal-back-button__link">
        {t(labelKey, '← Portal')}
      </a>
      <button
        type="button"
        className="portal-back-button__dismiss"
        onClick={() => setVisible(false)}
        aria-label={t(dismissKey, 'Dismiss')}
      >
        ×
      </button>
    </div>
  );
}
